import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import { ORDER_STORAGE_EXPIRY, ORDER_UUID_STORAGE_KEY, CART_NOTIFICATION_MAP, ADD_ITEM_NOTIFICATION_NAME, ORDER_SESSION_TOKEN_STORAGE_KEY } from './use-cart.constants';
import { getOrderStorageKey, transformCatalogItemToOrderItem } from './use-cart.utils';
import { ActionName } from '../../components/RecaptchaProvider/RecaptchaProvider.constants';
import { useRecaptcha } from '../../components/RecaptchaProvider/RecaptchaProvider.hooks';
import { createOrder, addOrderLineItem, getOrder } from '../../utils/api';
import useNotifications from '../use-notifications';
import useStorage from '../use-storage';
export default function useCart() {
  var merchant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$originalOrder = _ref.originalOrder,
    originalOrder = _ref$originalOrder === void 0 ? {} : _ref$originalOrder;
  var _useRecaptcha = useRecaptcha(),
    _useRecaptcha2 = _slicedToArray(_useRecaptcha, 2),
    executeRecaptcha = _useRecaptcha2[0],
    recaptchaLoaded = _useRecaptcha2[1];
  var _useNotifications = useNotifications(),
    notifications = _useNotifications.notifications,
    addNotification = _useNotifications.addNotification,
    removeNotification = _useNotifications.removeNotification,
    clearNotifications = _useNotifications.clearNotifications;
  var productUuid = merchant.productUuid,
    locationUuid = merchant.locationUuid;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    items = _useState4[0],
    setItems = _useState4[1];
  var _useState5 = useState(_cloneDeep(originalOrder)),
    _useState6 = _slicedToArray(_useState5, 2),
    order = _useState6[0],
    setOrder = _useState6[1];
  var orderUuidKey = getOrderStorageKey(ORDER_UUID_STORAGE_KEY, productUuid, locationUuid);
  var _useStorage = useStorage(orderUuidKey, '', {
      expiry: ORDER_STORAGE_EXPIRY
    }),
    _useStorage2 = _slicedToArray(_useStorage, 3),
    orderUuid = _useStorage2[0],
    setOrderUuid = _useStorage2[1],
    storageLoaded = _useStorage2[2];
  var sessionTokenKey = getOrderStorageKey(ORDER_SESSION_TOKEN_STORAGE_KEY, productUuid, locationUuid);
  var _useStorage3 = useStorage(sessionTokenKey, '', {
      expiry: ORDER_STORAGE_EXPIRY
    }),
    _useStorage4 = _slicedToArray(_useStorage3, 2),
    orderSessionToken = _useStorage4[0],
    setOrderSessionToken = _useStorage4[1];
  function setNewOrder() {
    var newOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _newOrder$uuid = newOrder.uuid,
      newUuid = _newOrder$uuid === void 0 ? '' : _newOrder$uuid,
      _newOrder$line_items = newOrder.line_items,
      newLineItems = _newOrder$line_items === void 0 ? [] : _newOrder$line_items,
      newSessionToken = newOrder.session_token;
    setOrder(newOrder);
    setItems(newLineItems);
    if (newUuid && newUuid !== orderUuid) {
      setOrderUuid(newUuid);
    }
    if (newSessionToken && newSessionToken !== orderSessionToken) {
      setOrderSessionToken(newSessionToken);
    }
  }
  function clearCart() {
    setItems([]);
    setOrder({});
    setOrderSessionToken('');
  }
  function handleError(e) {
    var throwError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var status = +_get(e, 'response.status', 400);
    if (status === 401 || status === 403 || status === 404) {
      clearCart();
    }
    if (throwError) {
      throw e;
    }
  }
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var nextOrder;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(storageLoaded && orderUuid && orderSessionToken)) {
            _context.next = 11;
            break;
          }
          _context.prev = 1;
          _context.next = 4;
          return getOrder(orderUuid, orderSessionToken);
        case 4:
          nextOrder = _context.sent;
          setNewOrder(nextOrder);
          _context.next = 11;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
          handleError(_context.t0, false);
        case 11:
          setLoading(false);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 8]]);
  })), [storageLoaded]);
  function addItem(_x) {
    return _addItem.apply(this, arguments);
  }
  function _addItem() {
    _addItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(item) {
      var nextOrder, orderItem, recaptchaToken, _recaptchaToken;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            nextOrder = {};
            orderItem = transformCatalogItemToOrderItem(item);
            _context2.prev = 2;
            setLoading(true);
            if (!(items.length > 0 && orderUuid && orderSessionToken)) {
              _context2.next = 13;
              break;
            }
            _context2.next = 7;
            return executeRecaptcha(ActionName.ADD_ORDER_ITEM);
          case 7:
            recaptchaToken = _context2.sent;
            _context2.next = 10;
            return addOrderLineItem(orderUuid, orderItem, recaptchaToken, orderSessionToken);
          case 10:
            nextOrder = _context2.sent;
            _context2.next = 19;
            break;
          case 13:
            _context2.next = 15;
            return executeRecaptcha(ActionName.CREATE_ORDER);
          case 15:
            _recaptchaToken = _context2.sent;
            _context2.next = 18;
            return createOrder(productUuid, locationUuid, _recaptchaToken, [orderItem]);
          case 18:
            nextOrder = _context2.sent;
          case 19:
            setNewOrder(nextOrder);
            addNotification(CART_NOTIFICATION_MAP[ADD_ITEM_NOTIFICATION_NAME]);
            _context2.next = 26;
            break;
          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](2);
            handleError(_context2.t0);
          case 26:
            _context2.prev = 26;
            setLoading(false);
            return _context2.finish(26);
          case 29:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 23, 26, 29]]);
    }));
    return _addItem.apply(this, arguments);
  }
  function getItemIndex(item) {
    var lookupFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (key) {
      return key;
    };
    return items.map(function (aItem) {
      return lookupFunc(aItem);
    }).indexOf(lookupFunc(item));
  }
  function removeItem(_x2) {
    return _removeItem.apply(this, arguments);
  }
  function _removeItem() {
    _removeItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(index) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setItems(function (previousItems) {
              return [].concat(_toConsumableArray(previousItems.slice(0, index)), _toConsumableArray(previousItems.slice(index + 1, items.length)));
            });
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _removeItem.apply(this, arguments);
  }
  function updateItem(_x3, _x4) {
    return _updateItem.apply(this, arguments);
  }
  function _updateItem() {
    _updateItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(item, index) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            setItems(function (previousItems) {
              return [].concat(_toConsumableArray(previousItems.slice(0, index)), [item], _toConsumableArray(previousItems.slice(index + 1, items.length)));
            });
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _updateItem.apply(this, arguments);
  }
  function containsItem(itemToSearch) {
    var comparisonFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (key) {
      return key;
    };
    return items.map(function (item) {
      return comparisonFunc(item);
    }).includes(comparisonFunc(itemToSearch));
  }

  // @deprecated
  function isOpen() {
    // TODO we should remove this function
    return true;
  }
  return {
    items: items,
    loading: loading || !recaptchaLoaded,
    getItemIndex: getItemIndex,
    addItem: addItem,
    removeItem: removeItem,
    updateItem: updateItem,
    containsItem: containsItem,
    clearCart: clearCart,
    orderId: orderUuid,
    setNewOrder: setNewOrder,
    order: order,
    orderSessionToken: orderSessionToken,
    isOpen: isOpen(),
    recaptchaLoaded: recaptchaLoaded,
    notifications: notifications,
    addNotification: addNotification,
    removeNotification: removeNotification,
    clearNotifications: clearNotifications
  };
}